import { useRouter } from 'next/router';
import queryString from 'query-string';
import { useEffect } from 'react';

import {
  API_ENDPOINT,
  useClientApiV1AuthSsoRedirectQuery,
} from '../../resources/@types/accountSchema';
import { useReferUrlNavigation } from '../hooks/useReferUrlNavigation';

function useClientAuthSsoRedirectQuery(
  options?: Parameters<typeof useClientApiV1AuthSsoRedirectQuery>[0]['options'],
  isFirst = false,
) {
  const { getReferUrl, navigateMainUrl } = useReferUrlNavigation();
  const router = useRouter();

  const { data, isSuccess, isError } = useClientApiV1AuthSsoRedirectQuery({
    queryKey: [API_ENDPOINT.CLIENT_V1_AUTH_SSO_REDIRECT],
    url: queryString.stringifyUrl({
      url: API_ENDPOINT.CLIENT_V1_AUTH_SSO_REDIRECT,
      query: {
        ...router.query,
        referUrl: getReferUrl(isFirst),
      },
    }),
    options,
  });

  useEffect(() => {
    if (!isFirst && isError) {
      navigateMainUrl();
    }
  }, [isError, isFirst, navigateMainUrl]);

  useEffect(() => {
    /**
     * @see {@link https://github.com/inflearn/inflearn-ucc-frontend/pull/415}
     * 여러 컴포넌트에서 같은 쿼리를 사용하고 있어 isSuccess 상태가 공유되고 있음 (queryKey가 같음)
     * options.enabled가 false인데도 다른 곳에서 성공할 경우 아래 로직이 실행될 수 있음
     * 따라서 options.enabled가 true인지 확인하는 조건이 필요함
     */
    if (!options?.enabled || !isSuccess || !data) {
      return;
    }

    location.href = data.redirectUrl;
  }, [isSuccess, data, options?.enabled]);
}

useClientAuthSsoRedirectQuery.queryKey = [API_ENDPOINT.CLIENT_V1_AUTH_SSO_REDIRECT];

export default useClientAuthSsoRedirectQuery;
